import React, {useEffect, useState} from "react";
import './header.css';
import cross from '../../assets/clear-24px.svg';
import burgerMenuIcon from '../../assets/burger-menu-icon.png';
import logo from '../../assets/logo/logo solo colour.png';
import logoText from '../../assets/logo/name solo black.png';
import {UserApi} from "../../api_client/generated/User";

export default function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        UserApi.get_me.f().then(setUser);
    }, []);

    const menuItems = [
        {
            title: 'organization',
            url: '/organization',
            require_scope: 'employee'
        },
        {
            title: 'Live View',
            url: '/live',
            require_scope: 'employee'
        },
        {
            title: 'Sessions',
            url: '/session'
        },
        {
            title: 'Water profiles',
            url: '/water-profile',
            require_scope: 'employee'
        },
        {
            title: 'Logout',
            url: '/logout'
        }
    ]

    return <>
        <div className='header'>
            <a href='/' className='header-title'>
                <img src={logoText} alt='logo text' className='logo-text'/>
                <img src={logo} alt='logo' className='logo'/>
            </a>
            <div className='spacer'>&nbsp;</div>
            <img src={menuOpen ? cross : burgerMenuIcon}
                 alt='open or close menu'
                 className={`burger-menu-icon ${menuOpen ? 'isopen' : ''}`}
                 onClick={() => setMenuOpen(p => !p)}/>
            <div className='inline-menu'>
                {user && menuItems.filter(i => !i.require_scope || i.require_scope === user.scope).map((item, index) =>
                    <a key={item.url} href={item.url} className='menu-item'>{item.title}</a>
                )}
            </div>
        </div>
        {user && menuOpen && <div className='menu-overlay' onClick={() => setMenuOpen(false)}>
            <div className='mobile-menu'>
                {menuItems.filter(i => !i.require_scope || i.require_scope === user.scope).map((item, index) =>
                    <a key={item.url} href={item.url} className='menu-item'>{item.title}</a>
                )}
            </div>
        </div>}
    </>
}
